import { render, staticRenderFns } from "./SectionFinal.vue?vue&type=template&id=a2360656&scoped=true"
import script from "./SectionFinal.vue?vue&type=script&lang=js"
export * from "./SectionFinal.vue?vue&type=script&lang=js"
import style0 from "./SectionFinal.vue?vue&type=style&index=0&id=a2360656&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2360656",
  null
  
)

export default component.exports